// Auto-generated from gen_weather_rate.ts
// DO NOT EDIT THIS FILE DIRECTLY

type WeatherRateType = {
  [zoneId: number]: {
    readonly rates: number[];
    readonly weathers: string[];
  };
};

const data: WeatherRateType = {
  0: {
    'rates': [
      100,
    ],
    'weathers': [
      'Fair Skies',
    ],
  },
  1: {
    'rates': [
      5,
      20,
      30,
      40,
      55,
      85,
      100,
    ],
    'weathers': [
      'Rain',
      'Rain',
      'Fog',
      'Clouds',
      'Fair Skies',
      'Clear Skies',
      'Fair Skies',
    ],
  },
  2: {
    'rates': [
      5,
      20,
      30,
      40,
      55,
      85,
      100,
    ],
    'weathers': [
      'Rain',
      'Rain',
      'Fog',
      'Clouds',
      'Fair Skies',
      'Clear Skies',
      'Fair Skies',
    ],
  },
  3: {
    'rates': [
      5,
      20,
      30,
      40,
      55,
      85,
      100,
    ],
    'weathers': [
      'Thunder',
      'Rain',
      'Fog',
      'Clouds',
      'Fair Skies',
      'Clear Skies',
      'Fair Skies',
    ],
  },
  4: {
    'rates': [
      5,
      20,
      30,
      40,
      55,
      85,
      100,
    ],
    'weathers': [
      'Thunder',
      'Rain',
      'Fog',
      'Clouds',
      'Fair Skies',
      'Clear Skies',
      'Fair Skies',
    ],
  },
  5: {
    'rates': [
      5,
      10,
      25,
      30,
      40,
      70,
      100,
    ],
    'weathers': [
      'Fog',
      'Thunderstorms',
      'Thunder',
      'Fog',
      'Clouds',
      'Fair Skies',
      'Clear Skies',
    ],
  },
  6: {
    'rates': [
      5,
      10,
      25,
      30,
      40,
      70,
      100,
    ],
    'weathers': [
      'Fog',
      'Showers',
      'Rain',
      'Fog',
      'Clouds',
      'Fair Skies',
      'Clear Skies',
    ],
  },
  7: {
    'rates': [
      40,
      60,
      85,
      95,
      100,
    ],
    'weathers': [
      'Clear Skies',
      'Fair Skies',
      'Clouds',
      'Fog',
      'Rain',
    ],
  },
  8: {
    'rates': [
      40,
      60,
      85,
      95,
      100,
    ],
    'weathers': [
      'Clear Skies',
      'Fair Skies',
      'Clouds',
      'Fog',
      'Rain',
    ],
  },
  9: {
    'rates': [
      40,
      60,
      85,
      95,
      100,
    ],
    'weathers': [
      'Clear Skies',
      'Fair Skies',
      'Clouds',
      'Fog',
      'Rain',
    ],
  },
  10: {
    'rates': [
      15,
      55,
      75,
      85,
      95,
      100,
    ],
    'weathers': [
      'Dust Storms',
      'Clear Skies',
      'Fair Skies',
      'Clouds',
      'Fog',
      'Rain',
    ],
  },
  11: {
    'rates': [
      40,
      60,
      70,
      80,
      85,
      100,
    ],
    'weathers': [
      'Clear Skies',
      'Fair Skies',
      'Clouds',
      'Fog',
      'Rain',
      'Showers',
    ],
  },
  12: {
    'rates': [
      20,
      60,
      80,
      90,
      100,
    ],
    'weathers': [
      'Heat Waves',
      'Clear Skies',
      'Fair Skies',
      'Clouds',
      'Fog',
    ],
  },
  13: {
    'rates': [
      5,
      20,
      50,
      100,
    ],
    'weathers': [
      'Clear Skies',
      'Fair Skies',
      'Clouds',
      'Fog',
    ],
  },
  14: {
    'rates': [
      20,
      50,
      80,
      90,
      100,
    ],
    'weathers': [
      'Clouds',
      'Clear Skies',
      'Fair Skies',
      'Fog',
      'Rain',
    ],
  },
  15: {
    'rates': [
      20,
      50,
      80,
      90,
      100,
    ],
    'weathers': [
      'Clouds',
      'Clear Skies',
      'Fair Skies',
      'Fog',
      'Rain',
    ],
  },
  16: {
    'rates': [
      20,
      50,
      70,
      80,
      90,
      100,
    ],
    'weathers': [
      'Clouds',
      'Clear Skies',
      'Fair Skies',
      'Wind',
      'Fog',
      'Rain',
    ],
  },
  17: {
    'rates': [
      20,
      50,
      70,
      80,
      90,
      100,
    ],
    'weathers': [
      'Clouds',
      'Clear Skies',
      'Fair Skies',
      'Wind',
      'Fog',
      'Rain',
    ],
  },
  18: {
    'rates': [
      5,
      50,
      80,
      90,
      95,
      100,
    ],
    'weathers': [
      'Fog',
      'Clear Skies',
      'Fair Skies',
      'Clouds',
      'Rain',
      'Showers',
    ],
  },
  19: {
    'rates': [
      10,
      40,
      60,
      80,
      90,
      100,
    ],
    'weathers': [
      'Fog',
      'Clear Skies',
      'Fair Skies',
      'Clouds',
      'Wind',
      'Gales',
    ],
  },
  20: {
    'rates': [
      30,
      50,
      70,
      80,
      90,
      100,
    ],
    'weathers': [
      'Clear Skies',
      'Fair Skies',
      'Clouds',
      'Fog',
      'Thunder',
      'Thunderstorms',
    ],
  },
  21: {
    'rates': [
      20,
      60,
      70,
      75,
      90,
      100,
    ],
    'weathers': [
      'Blizzards',
      'Snow',
      'Fair Skies',
      'Clear Skies',
      'Clouds',
      'Fog',
    ],
  },
  22: {
    'rates': [
      15,
      30,
      60,
      75,
      100,
    ],
    'weathers': [
      'Clouds',
      'Fog',
      'Gloom',
      'Clear Skies',
      'Fair Skies',
    ],
  },
  23: {
    'rates': [
      100,
    ],
    'weathers': [
      'Eruptions',
    ],
  },
  24: {
    'rates': [
      30,
      50,
      70,
      85,
      100,
    ],
    'weathers': [
      'Clear Skies',
      'Fair Skies',
      'Clouds',
      'Fog',
      'Rain',
    ],
  },
  25: {
    'rates': [
      100,
    ],
    'weathers': [
      'Heat Waves',
    ],
  },
  26: {
    'rates': [
      100,
    ],
    'weathers': [
      'Gales',
    ],
  },
  27: {
    'rates': [
      100,
    ],
    'weathers': [
      'Snow',
    ],
  },
  28: {
    'rates': [
      100,
    ],
    'weathers': [
      'Clouds',
    ],
  },
  29: {
    'rates': [
      20,
      50,
      80,
      90,
      100,
    ],
    'weathers': [
      'Clouds',
      'Clear Skies',
      'Fair Skies',
      'Fog',
      'Thunderstorms',
    ],
  },
  30: {
    'rates': [
      100,
    ],
    'weathers': [
      'Gloom',
    ],
  },
  31: {
    'rates': [
      100,
    ],
    'weathers': [
      'Louring',
    ],
  },
  32: {
    'rates': [
      20,
      50,
      70,
      80,
      90,
      100,
    ],
    'weathers': [
      'Clouds',
      'Clear Skies',
      'Fair Skies',
      'Fair Skies',
      'Fog',
      'Rain',
    ],
  },
  33: {
    'rates': [
      40,
      60,
      85,
      95,
      100,
    ],
    'weathers': [
      'Clear Skies',
      'Fair Skies',
      'Clouds',
      'Fog',
      'Rain',
    ],
  },
  34: {
    'rates': [
      5,
      20,
      30,
      40,
      55,
      85,
      100,
    ],
    'weathers': [
      'Clouds',
      'Rain',
      'Fog',
      'Clouds',
      'Fair Skies',
      'Clear Skies',
      'Fair Skies',
    ],
  },
  35: {
    'rates': [
      100,
    ],
    'weathers': [
      'Snow',
    ],
  },
  36: {
    'rates': [
      100,
    ],
    'weathers': [
      'Wind',
    ],
  },
  37: {
    'rates': [
      100,
    ],
    'weathers': [
      'Thunder',
    ],
  },
  38: {
    'rates': [
      100,
    ],
    'weathers': [
      'Rough Seas',
    ],
  },
  39: {
    'rates': [
      100,
    ],
    'weathers': [
      'Rough Seas',
    ],
  },
  40: {
    'rates': [
      100,
    ],
    'weathers': [
      'Fog',
    ],
  },
  41: {
    'rates': [
      100,
    ],
    'weathers': [
      'Dust Storms',
    ],
  },
  42: {
    'rates': [
      100,
    ],
    'weathers': [
      'Blizzards',
    ],
  },
  43: {
    'rates': [
      100,
    ],
    'weathers': [
      'Storm Clouds',
    ],
  },
  44: {
    'rates': [
      100,
    ],
    'weathers': [
      'Core Radiation',
    ],
  },
  45: {
    'rates': [
      100,
    ],
    'weathers': [
      'Tension',
    ],
  },
  46: {
    'rates': [
      100,
    ],
    'weathers': [
      'Irradiance',
    ],
  },
  47: {
    'rates': [
      60,
      70,
      75,
      90,
      100,
    ],
    'weathers': [
      'Snow',
      'Fair Skies',
      'Clear Skies',
      'Clouds',
      'Fog',
    ],
  },
  48: {
    'rates': [
      60,
      70,
      75,
      90,
      100,
    ],
    'weathers': [
      'Snow',
      'Fair Skies',
      'Clear Skies',
      'Clouds',
      'Fog',
    ],
  },
  49: {
    'rates': [
      20,
      60,
      70,
      75,
      90,
      100,
    ],
    'weathers': [
      'Blizzards',
      'Snow',
      'Fair Skies',
      'Clear Skies',
      'Clouds',
      'Fog',
    ],
  },
  50: {
    'rates': [
      10,
      20,
      30,
      40,
      70,
      100,
    ],
    'weathers': [
      'Clouds',
      'Fog',
      'Thunder',
      'Dust Storms',
      'Clear Skies',
      'Fair Skies',
    ],
  },
  51: {
    'rates': [
      10,
      20,
      30,
      40,
      70,
      100,
    ],
    'weathers': [
      'Clouds',
      'Fog',
      'Rain',
      'Showers',
      'Clear Skies',
      'Fair Skies',
    ],
  },
  52: {
    'rates': [
      10,
      20,
      40,
      70,
      100,
    ],
    'weathers': [
      'Clouds',
      'Gales',
      'Umbral Static',
      'Clear Skies',
      'Fair Skies',
    ],
  },
  53: {
    'rates': [
      30,
      60,
      70,
      80,
      90,
      100,
    ],
    'weathers': [
      'Clear Skies',
      'Fair Skies',
      'Clouds',
      'Fog',
      'Wind',
      'Umbral Wind',
    ],
  },
  54: {
    'rates': [
      35,
      70,
      100,
    ],
    'weathers': [
      'Fair Skies',
      'Clouds',
      'Thunder',
    ],
  },
  55: {
    'rates': [
      10,
      20,
      30,
      40,
      70,
      100,
    ],
    'weathers': [
      'Clouds',
      'Fog',
      'Rain',
      'Showers',
      'Clear Skies',
      'Fair Skies',
    ],
  },
  56: {
    'rates': [
      100,
    ],
    'weathers': [
      'Oppression',
    ],
  },
  57: {
    'rates': [
      100,
    ],
    'weathers': [
      'Smoke',
    ],
  },
  58: {
    'rates': [
      100,
    ],
    'weathers': [
      'Clear Skies',
    ],
  },
  59: {
    'rates': [
      15,
      40,
      100,
    ],
    'weathers': [
      'Fog',
      'Rain',
      'Fair Skies',
    ],
  },
  60: {
    'rates': [
      40,
      75,
      95,
      99,
      100,
    ],
    'weathers': [
      'Fair Skies',
      'Fog',
      'Wind',
      'Umbral Wind',
      'Hyperelectricity',
    ],
  },
  61: {
    'rates': [
      40,
      60,
      95,
      99,
      100,
    ],
    'weathers': [
      'Fair Skies',
      'Fog',
      'Wind',
      'Umbral Wind',
      'Hyperelectricity',
    ],
  },
  62: {
    'rates': [
      40,
      65,
      90,
      98,
      100,
    ],
    'weathers': [
      'Fair Skies',
      'Fog',
      'Wind',
      'Umbral Wind',
      'Hyperelectricity',
    ],
  },
  63: {
    'rates': [
      100,
    ],
    'weathers': [
      'Rain',
    ],
  },
  64: {
    'rates': [
      60,
      100,
    ],
    'weathers': [
      'Fair Skies',
      'Rain',
    ],
  },
  65: {
    'rates': [
      50,
      100,
    ],
    'weathers': [
      'Fair Skies',
      'Rain',
    ],
  },
  66: {
    'rates': [
      100,
    ],
    'weathers': [
      'Multiplicity',
    ],
  },
  67: {
    'rates': [
      35,
      65,
      85,
      100,
    ],
    'weathers': [
      'Fair Skies',
      'Snow',
      'Blizzards',
      'Fog',
    ],
  },
  68: {
    'rates': [
      100,
    ],
    'weathers': [
      'Heat Waves',
    ],
  },
  69: {
    'rates': [
      100,
    ],
    'weathers': [
      'Concordance',
    ],
  },
  70: {
    'rates': [
      100,
    ],
    'weathers': [
      'Hyperelectricity',
    ],
  },
  71: {
    'rates': [
      30,
      60,
      90,
      100,
    ],
    'weathers': [
      'Fair Skies',
      'Fog',
      'Wind',
      'Umbral Wind',
    ],
  },
  72: {
    'rates': [
      65,
      100,
    ],
    'weathers': [
      'Fair Skies',
      'Rain',
    ],
  },
  73: {
    'rates': [
      65,
      100,
    ],
    'weathers': [
      'Fair Skies',
      'Rain',
    ],
  },
  74: {
    'rates': [
      100,
    ],
    'weathers': [
      'Gloom',
    ],
  },
  75: {
    'rates': [
      100,
    ],
    'weathers': [
      'Demonic Infinity',
    ],
  },
  76: {
    'rates': [
      100,
    ],
    'weathers': [
      'Wyrmstorms',
    ],
  },
  77: {
    'rates': [
      100,
    ],
    'weathers': [
      'Revelstorms',
    ],
  },
  78: {
    'rates': [
      15,
      60,
      80,
      90,
      100,
    ],
    'weathers': [
      'Clear Skies',
      'Fair Skies',
      'Clouds',
      'Fog',
      'Thunder',
    ],
  },
  79: {
    'rates': [
      15,
      60,
      80,
      90,
      100,
    ],
    'weathers': [
      'Clear Skies',
      'Fair Skies',
      'Clouds',
      'Fog',
      'Thunder',
    ],
  },
  80: {
    'rates': [
      10,
      60,
      75,
      85,
      95,
      100,
    ],
    'weathers': [
      'Clear Skies',
      'Fair Skies',
      'Clouds',
      'Fog',
      'Wind',
      'Dust Storms',
    ],
  },
  81: {
    'rates': [
      20,
      60,
      80,
      90,
      100,
    ],
    'weathers': [
      'Clear Skies',
      'Fair Skies',
      'Clouds',
      'Fog',
      'Thunderstorms',
    ],
  },
  82: {
    'rates': [
      10,
      20,
      40,
      80,
      100,
    ],
    'weathers': [
      'Rain',
      'Fog',
      'Clouds',
      'Fair Skies',
      'Clear Skies',
    ],
  },
  83: {
    'rates': [
      10,
      20,
      35,
      75,
      100,
    ],
    'weathers': [
      'Thunder',
      'Wind',
      'Clouds',
      'Fair Skies',
      'Clear Skies',
    ],
  },
  84: {
    'rates': [
      5,
      15,
      25,
      40,
      80,
      100,
    ],
    'weathers': [
      'Showers',
      'Rain',
      'Fog',
      'Clouds',
      'Fair Skies',
      'Clear Skies',
    ],
  },
  85: {
    'rates': [
      5,
      10,
      17,
      25,
      35,
      75,
      100,
    ],
    'weathers': [
      'Gales',
      'Wind',
      'Rain',
      'Fog',
      'Clouds',
      'Fair Skies',
      'Clear Skies',
    ],
  },
  86: {
    'rates': [
      100,
    ],
    'weathers': [
      'Umbral Static',
    ],
  },
  87: {
    'rates': [
      100,
    ],
    'weathers': [
      'Eternal Bliss',
    ],
  },
  88: {
    'rates': [
      100,
    ],
    'weathers': [
      'Dimensional Disruption',
    ],
  },
  89: {
    'rates': [
      100,
    ],
    'weathers': [
      'Thunder',
    ],
  },
  90: {
    'rates': [
      100,
    ],
    'weathers': [
      'Fair Skies',
    ],
  },
  91: {
    'rates': [
      30,
      60,
      90,
      100,
    ],
    'weathers': [
      'Fair Skies',
      'Gales',
      'Showers',
      'Snow',
    ],
  },
  92: {
    'rates': [
      100,
    ],
    'weathers': [
      'Dimensional Disruption',
    ],
  },
  93: {
    'rates': [
      100,
    ],
    'weathers': [
      'White Cyclones',
    ],
  },
  94: {
    'rates': [
      10,
      28,
      46,
      64,
      82,
      100,
    ],
    'weathers': [
      'Fair Skies',
      'Fog',
      'Heat Waves',
      'Snow',
      'Thunder',
      'Blizzards',
    ],
  },
  95: {
    'rates': [
      100,
    ],
    'weathers': [
      'Red Moon',
    ],
  },
  96: {
    'rates': [
      10,
      28,
      46,
      64,
      82,
      100,
    ],
    'weathers': [
      'Fair Skies',
      'Heat Waves',
      'Thunder',
      'Blizzards',
      'Umbral Wind',
      'Snow',
    ],
  },
  97: {
    'rates': [
      100,
    ],
    'weathers': [
      'Sandstorms',
    ],
  },
  98: {
    'rates': [
      100,
    ],
    'weathers': [
      'Scarlet',
    ],
  },
  99: {
    'rates': [
      100,
    ],
    'weathers': [
      'True Blue',
    ],
  },
  100: {
    'rates': [
      12,
      34,
      56,
      78,
      100,
    ],
    'weathers': [
      'Fair Skies',
      'Showers',
      'Gloom',
      'Thunderstorms',
      'Snow',
    ],
  },
  101: {
    'rates': [
      100,
    ],
    'weathers': [
      'Gales',
    ],
  },
  102: {
    'rates': [
      100,
    ],
    'weathers': [
      'Everlasting Light',
    ],
  },
  103: {
    'rates': [
      100,
    ],
    'weathers': [
      'Dreams',
    ],
  },
  104: {
    'rates': [
      100,
    ],
    'weathers': [
      'Brilliance',
    ],
  },
  105: {
    'rates': [
      100,
    ],
    'weathers': [
      'Termination',
    ],
  },
  106: {
    'rates': [
      20,
      60,
      75,
      85,
      95,
      100,
    ],
    'weathers': [
      'Clear Skies',
      'Fair Skies',
      'Clouds',
      'Fog',
      'Rain',
      'Thunderstorms',
    ],
  },
  107: {
    'rates': [
      10,
      20,
      30,
      45,
      85,
      100,
    ],
    'weathers': [
      'Gales',
      'Rain',
      'Fog',
      'Clouds',
      'Fair Skies',
      'Clear Skies',
    ],
  },
  108: {
    'rates': [
      45,
      60,
      70,
      80,
      100,
    ],
    'weathers': [
      'Fair Skies',
      'Clouds',
      'Dust Storms',
      'Heat Waves',
      'Clear Skies',
    ],
  },
  109: {
    'rates': [
      10,
      20,
      35,
      45,
      60,
      100,
    ],
    'weathers': [
      'Rain',
      'Fog',
      'Clouds',
      'Thunderstorms',
      'Clear Skies',
      'Fair Skies',
    ],
  },
  110: {
    'rates': [
      10,
      20,
      30,
      45,
      85,
      100,
    ],
    'weathers': [
      'Fog',
      'Rain',
      'Umbral Wind',
      'Clear Skies',
      'Fair Skies',
      'Clouds',
    ],
  },
  111: {
    'rates': [
      20,
      80,
      100,
    ],
    'weathers': [
      'Clouds',
      'Fair Skies',
      'Clear Skies',
    ],
  },
  112: {
    'rates': [
      20,
      60,
      75,
      85,
      95,
      100,
    ],
    'weathers': [
      'Clear Skies',
      'Fair Skies',
      'Clouds',
      'Fog',
      'Rain',
      'Thunderstorms',
    ],
  },
  113: {
    'rates': [
      10,
      20,
      30,
      45,
      85,
      100,
    ],
    'weathers': [
      'Gales',
      'Rain',
      'Fog',
      'Clouds',
      'Fair Skies',
      'Clear Skies',
    ],
  },
  114: {
    'rates': [
      100,
    ],
    'weathers': [
      'Fair Skies',
    ],
  },
  115: {
    'rates': [
      100,
    ],
    'weathers': [
      'Thunderstorms',
    ],
  },
  116: {
    'rates': [
      100,
    ],
    'weathers': [
      'Termination',
    ],
  },
  117: {
    'rates': [
      50,
      80,
      90,
      95,
      100,
    ],
    'weathers': [
      'Fair Skies',
      'Wind',
      'Rain',
      'Gales',
      'Fog',
    ],
  },
  118: {
    'rates': [
      50,
      100,
    ],
    'weathers': [
      'Clear Skies',
      'Fair Skies',
    ],
  },
  119: {
    'rates': [
      45,
      63,
      80,
      95,
      100,
    ],
    'weathers': [
      'Fair Skies',
      'Clouds',
      'Fog',
      'Rain',
      'Showers',
    ],
  },
  120: {
    'rates': [
      40,
      55,
      70,
      95,
      100,
    ],
    'weathers': [
      'Fair Skies',
      'Clouds',
      'Fog',
      'Wind',
      'Gales',
    ],
  },
  121: {
    'rates': [
      35,
      50,
      65,
      85,
      100,
    ],
    'weathers': [
      'Fair Skies',
      'Clouds',
      'Fog',
      'Snow',
      'Blizzards',
    ],
  },
  122: {
    'rates': [
      82,
      87,
      92,
      97,
      100,
    ],
    'weathers': [
      'Fair Skies',
      'Clouds',
      'Fog',
      'Dust Storms',
      'Heat Waves',
    ],
  },
  123: {
    'rates': [
      100,
    ],
    'weathers': [
      'Delirium',
    ],
  },
  124: {
    'rates': [
      52,
      64,
      76,
      88,
      100,
    ],
    'weathers': [
      'Fair Skies',
      'Rain',
      'Wind',
      'Thunder',
      'Dust Storms',
    ],
  },
  125: {
    'rates': [
      100,
    ],
    'weathers': [
      'Starshower',
    ],
  },
  126: {
    'rates': [
      100,
    ],
    'weathers': [
      'Climactic',
    ],
  },
  127: {
    'rates': [
      50,
      65,
      80,
      95,
      100,
    ],
    'weathers': [
      'Fair Skies',
      'Clouds',
      'Fog',
      'Thunder',
      'Thunderstorms',
    ],
  },
  128: {
    'rates': [
      40,
      58,
      75,
      93,
      100,
    ],
    'weathers': [
      'Fair Skies',
      'Clouds',
      'Fog',
      'Rain',
      'Showers',
    ],
  },
  129: {
    'rates': [
      44,
      59,
      73,
      93,
      100,
    ],
    'weathers': [
      'Fair Skies',
      'Clouds',
      'Fog',
      'Thunder',
      'Thunderstorms',
    ],
  },
  130: {
    'rates': [
      60,
      70,
      80,
      90,
      100,
    ],
    'weathers': [
      'Fair Skies',
      'Rain',
      'Wind',
      'Thunder',
      'Snow',
    ],
  },
  131: {
    'rates': [
      15,
      60,
      85,
      100,
    ],
    'weathers': [
      'Clear Skies',
      'Fair Skies',
      'Clouds',
      'Rain',
    ],
  },
  132: {
    'rates': [
      10,
      20,
      25,
      40,
      80,
      100,
    ],
    'weathers': [
      'Fog',
      'Rain',
      'Showers',
      'Clear Skies',
      'Fair Skies',
      'Clouds',
    ],
  },
  133: {
    'rates': [
      45,
      50,
      55,
      60,
      85,
      95,
      100,
    ],
    'weathers': [
      'Snow',
      'Thunder',
      'Rain',
      'Fog',
      'Clouds',
      'Fair Skies',
      'Clear Skies',
    ],
  },
  134: {
    'rates': [
      25,
      40,
      85,
      100,
    ],
    'weathers': [
      'Clouds',
      'Umbral Wind',
      'Fair Skies',
      'Clear Skies',
    ],
  },
  135: {
    'rates': [
      15,
      30,
      100,
    ],
    'weathers': [
      'Umbral Wind',
      'Moon Dust',
      'Fair Skies',
    ],
  },
  136: {
    'rates': [
      15,
      85,
      100,
    ],
    'weathers': [
      'Astromagnetic Storms',
      'Fair Skies',
      'Umbral Wind',
    ],
  },
  137: {
    'rates': [
      10,
      50,
      70,
      85,
      100,
    ],
    'weathers': [
      'Clear Skies',
      'Fair Skies',
      'Clouds',
      'Fog',
      'Snow',
    ],
  },
  138: {
    'rates': [
      10,
      25,
      40,
      80,
      100,
    ],
    'weathers': [
      'Fog',
      'Rain',
      'Clear Skies',
      'Fair Skies',
      'Clouds',
    ],
  },
  139: {
    'rates': [
      100,
    ],
    'weathers': [
      'Polarization',
    ],
  },
  140: {
    'rates': [
      100,
    ],
    'weathers': [
      'Projection',
    ],
  },
  141: {
    'rates': [
      100,
    ],
    'weathers': [
      'Apocalypse',
    ],
  },
  142: {
    'rates': [
      5,
      25,
      65,
      80,
      90,
    ],
    'weathers': [
      'Snow',
      'Fair Skies',
      'Clear Skies',
      'Clouds',
      'Fog',
    ],
  },
  143: {
    'rates': [
      100,
    ],
    'weathers': [
      'Ultimatum',
    ],
  },
  144: {
    'rates': [
      100,
    ],
    'weathers': [
      'Inevitability',
    ],
  },
  145: {
    'rates': [
      100,
    ],
    'weathers': [
      'Pandæmonium',
    ],
  },
  146: {
    'rates': [
      100,
    ],
    'weathers': [
      'Termination',
    ],
  },
  147: {
    'rates': [
      100,
    ],
    'weathers': [
      'Transcendence',
    ],
  },
  148: {
    'rates': [
      25,
      70,
      80,
      90,
      95,
      100,
    ],
    'weathers': [
      'Clear Skies',
      'Fair Skies',
      'Clouds',
      'Rain',
      'Fog',
      'Showers',
    ],
  },
  149: {
    'rates': [
      100,
    ],
    'weathers': [
      'Vacuity',
    ],
  },
  150: {
    'rates': [
      100,
    ],
    'weathers': [
      'Dimensional Disruption',
    ],
  },
  151: {
    'rates': [
      50,
      65,
      80,
      95,
      100,
    ],
    'weathers': [
      'Fair Skies',
      'Clouds',
      'Fog',
      'Rain',
      'Thunderstorms',
    ],
  },
  152: {
    'rates': [
      50,
      65,
      80,
      95,
      100,
    ],
    'weathers': [
      'Fair Skies',
      'Clouds',
      'Fog',
      'Rain',
      'Showers',
    ],
  },
  153: {
    'rates': [
      40,
      55,
      70,
      90,
      100,
    ],
    'weathers': [
      'Fair Skies',
      'Clouds',
      'Fog',
      'Wind',
      'Thunder',
    ],
  },
  154: {
    'rates': [
      50,
      65,
      80,
      95,
      100,
    ],
    'weathers': [
      'Fair Skies',
      'Clouds',
      'Fog',
      'Rain',
      'Showers',
    ],
  },
  155: {
    'rates': [
      100,
    ],
    'weathers': [
      'Lyrical Catharsis',
    ],
  },
  156: {
    'rates': [
      100,
    ],
    'weathers': [
      'Thunderstorms',
    ],
  },
  157: {
    'rates': [
      100,
    ],
    'weathers': [
      'Projection',
    ],
  },
  158: {
    'rates': [
      100,
    ],
    'weathers': [
      'Liminality',
    ],
  },
  159: {
    'rates': [
      40,
      80,
      85,
      95,
      100,
    ],
    'weathers': [
      'Clear Skies',
      'Fair Skies',
      'Clouds',
      'Fog',
      'Rain',
    ],
  },
  160: {
    'rates': [
      20,
      50,
      70,
      80,
      90,
      100,
    ],
    'weathers': [
      'Clear Skies',
      'Fair Skies',
      'Clouds',
      'Fog',
      'Wind',
      'Snow',
    ],
  },
  161: {
    'rates': [
      25,
      60,
      75,
      85,
      95,
      100,
    ],
    'weathers': [
      'Clear Skies',
      'Fair Skies',
      'Clouds',
      'Fog',
      'Rain',
      'Showers',
    ],
  },
  162: {
    'rates': [
      15,
      55,
      70,
      85,
      100,
    ],
    'weathers': [
      'Clear Skies',
      'Fair Skies',
      'Clouds',
      'Fog',
      'Rain',
    ],
  },
  163: {
    'rates': [
      100,
    ],
    'weathers': [
      'Fair Skies',
    ],
  },
  164: {
    'rates': [
      5,
      50,
      70,
      85,
      100,
    ],
    'weathers': [
      'Clear Skies',
      'Fair Skies',
      'Clouds',
      'Dust Storms',
      'Gales',
    ],
  },
  165: {
    'rates': [
      5,
      25,
      40,
      45,
      50,
      100,
    ],
    'weathers': [
      'Fair Skies',
      'Clouds',
      'Fog',
      'Rain',
      'Thunderstorms',
      'Umbral Static',
    ],
  },
  166: {
    'rates': [
      10,
      20,
      40,
      100,
    ],
    'weathers': [
      'Rain',
      'Fog',
      'Clouds',
      'Fair Skies',
    ],
  },
  167: {
    'rates': [
      100,
    ],
    'weathers': [
      'Electrostatic Dust',
    ],
  },
  168: {
    'rates': [
      10,
      55,
      70,
      80,
      95,
      100,
    ],
    'weathers': [
      'Clear Skies',
      'Fair Skies',
      'Clouds',
      'Rain',
      'Atmospheric Phantasms',
      'Illusory Disturbances',
    ],
  },
  169: {
    'rates': [
      15,
      85,
      100,
    ],
    'weathers': [
      'Moon Dust',
      'Fair Skies',
      'Umbral Wind',
    ],
  },
  170: {
    'rates': [
      100,
    ],
    'weathers': [
      'Dying Breath',
    ],
  },
  171: {
    'rates': [
      60,
      80,
      100,
    ],
    'weathers': [
      'Fair Skies',
      'Clouds',
      'Rain',
    ],
  },
  172: {
    'rates': [
      20,
      80,
      100,
    ],
    'weathers': [
      'Clouds',
      'Fair Skies',
      'Clear Skies',
    ],
  },
  173: {
    'rates': [
      45,
      60,
      75,
      92,
      100,
    ],
    'weathers': [
      'Fair Skies',
      'Clouds',
      'Fog',
      'Rain',
      'Showers',
    ],
  },
  174: {
    'rates': [
      50,
      65,
      80,
      95,
      100,
    ],
    'weathers': [
      'Fair Skies',
      'Clouds',
      'Fog',
      'Rain',
      'Showers',
    ],
  },
};

export default data;
